import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formatter", "parser", "precision", "value", "error", "max", "min", "maxFractionDigits", "onBlur", "onChange", "onFocus", "onRawValueChange", "onKeyUp", "onKeyDown", "separator", "defaultValue", "disabled", "formatStyle", "inputRef", "placeholder", "readOnly", "styled", "type", "use", "name"];
import { Controllable } from '../Controllable';
import { forwardRef } from 'react';
import ShareInput from '../ShareInput/ShareInput';
import { AbstractNumberInput } from '../AbstractNumberInput/AbstractNumberInput';
import { TextInput } from '../TextInput/TextInput';
import { filterProps } from '../../../utils/filterProps';
import devLogger from 'react-utils/devLogger';
import { useComputedPlaceholder } from '../../../hooks/usePlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
export const NumberInputComponent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      formatter,
      parser,
      precision,
      value,
      error = false,
      max,
      min,
      maxFractionDigits,
      onBlur,
      onChange,
      onFocus,
      onRawValueChange,
      onKeyUp,
      onKeyDown,
      separator,
      defaultValue,
      disabled,
      formatStyle,
      inputRef,
      placeholder,
      readOnly,
      styled = true,
      type,
      use = 'default',
      name
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (type !== 'text') {
    devLogger.warn({
      message: 'NumberInput: The `type` prop is a no-op',
      key: 'NumberInput: type'
    });
  }
  const {
    domProps,
    tokenProps,
    restProps
  } = filterProps(rest);
  const computedPlaceholder = useComputedPlaceholder(placeholder);
  const inputProps = Object.assign({}, domProps, tokenProps, {
    disabled,
    formatStyle,
    inputRef: inputRef || ref,
    placeholder: computedPlaceholder,
    readOnly,
    styled,
    use,
    error,
    defaultValue
  });
  return /*#__PURE__*/_jsx(AbstractNumberInput, Object.assign({}, inputProps, restProps, {
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    max: max,
    min: min,
    maxFractionDigits: maxFractionDigits,
    onBlur: onBlur,
    onChange: onChange,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onRawValueChange: onRawValueChange,
    onKeyUp: onKeyUp,
    separator: separator,
    value: value,
    formatter: formatter,
    parser: parser,
    precision: precision,
    name: name,
    children: numberProps => /*#__PURE__*/_jsx(TextInput, Object.assign({}, numberProps, {
      type: "text"
    }))
  }));
});
export const NumberInput = ShareInput(Controllable(NumberInputComponent));
NumberInput.displayName = 'NumberInput';